export const SkillsData = [
    {
        type:"Language",
        list:[
            {
                name:"C",
                icon: <i class="devicon-c-plain colored"></i>
            },
            {
                name:"C++",
                icon: <i class="devicon-cplusplus-plain colored"></i>
            }
        ]
    },
    {
        type:"Frontend",
        list:[
            {
                name:"ReactJS",
                icon: <i class="devicon-react-original colored"></i>
            },
            {
                name:"Javascript",
                icon: <i class="devicon-javascript-plain"></i>
            },
            {
                name:"Typescript",
                icon: <i class="devicon-typescript-plain colored"></i>
            },
          
            {
                name:"CSS",
                icon: <i class="devicon-css3-plain colored"></i>

            }
        ]
    }
]